import React from 'react';
import { FunctionColor } from '@lux/core';
import { SvgIcon } from '../svg-icon';
import { IconSize } from '../types';
import { LongArch, ShortArch } from './styles';
export function Loading(props) {
    const { size, color: propColor } = props;
    const color = propColor || FunctionColor.function80;
    return (React.createElement(SvgIcon, Object.assign({}, props, { color: color, width: `${size}px`, height: `${size}px`, useStroke: true }),
        React.createElement(LongArch, { d: "M16 28.5C9.09644 28.5 3.5 22.9036 3.5 16C3.5 9.09644 9.09644 3.5 16 3.5C22.9036 3.5 28.5 9.09644 28.5 16C28.5 19.5749 27.0012 22.7973 24.5936 25.0775C22.3521 27.2003 19.3295 28.5 16 28.5Z" }),
        React.createElement(ShortArch, { d: "M15.5 3.5C22.5 3.5 28.5 8 28.5 16.5" })));
}
Loading.defaultProps = {
    viewBox: '0 0 32 32',
    size: IconSize.M,
};
export default Loading;
//# sourceMappingURL=Loading.js.map